import fifthaveClient from './fifthaveClient'

function login(username: string, password: string) {
  return fifthaveClient.post('/api/v1/signin', {
    username: username,
    password: password,
  })
}

export { login }
